import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=4d66b16c&"
import script from "./Google.vue?vue&type=script&lang=js&"
export * from "./Google.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d66b16c')) {
      api.createRecord('4d66b16c', component.options)
    } else {
      api.reload('4d66b16c', component.options)
    }
    module.hot.accept("./Google.vue?vue&type=template&id=4d66b16c&", function () {
      api.rerender('4d66b16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/Google.vue"
export default component.exports